export const timelineActionTypes = {
  SET_STATE: 'timeline/SET_STATE',
  GET_SESSIONS: 'timeline/GET_SESSIONS',
};
